import { Component } from '../flags.js'

export const Container = Component.t0.l0.h100vh.w100p.zi10.flex.ai_center.jc_center.fixed.div()
export const Insert = Component.flex.flex_column.pa50.w300.h50p.shadow_a_s.bg_white.div()
export const Name = Component.fs25.mb10.div()
export const Seller = Component.mono.fs13.grey4.mb25.div()
export const Field = Component.mt10.mono.fs15.grey4.ol_none.ba0.pa0.input()
export const TextArea = Component.mt10.h100.mono.fs15.grey4.ol_none.ba0.pa0.textarea()